import { createMuiTheme } from '@material-ui/core/styles';
// import purple from '@material-ui/core/colors/purple';
// import green from '@material-ui/core/colors/green';
// import { dark } from '@material-ui/core/styles/createPalette';

const theme = createMuiTheme({
  palette: {
    type: 'light'
  }
});

export default theme;
